"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NotificationAppearance = void 0;
let NotificationAppearance = exports.NotificationAppearance = /*#__PURE__*/ function(NotificationAppearance) {
    NotificationAppearance[NotificationAppearance["ShopppingBag"] = 1] = "ShopppingBag";
    NotificationAppearance[NotificationAppearance["Information"] = 2] = "Information";
    NotificationAppearance[NotificationAppearance["Offers"] = 4] = "Offers";
    NotificationAppearance[NotificationAppearance["Delivery"] = 8] = "Delivery";
    NotificationAppearance[NotificationAppearance["Payments"] = 16] = "Payments";
    NotificationAppearance[NotificationAppearance["Beauty"] = 32] = "Beauty";
    NotificationAppearance[NotificationAppearance["Review"] = 64] = "Review";
    NotificationAppearance[NotificationAppearance["Subscriptions"] = 128] = "Subscriptions";
    NotificationAppearance[NotificationAppearance["All"] = 255] = "All";
    return NotificationAppearance;
}({});
